module.exports = __webpack_public_path__ + "static/Maira-24d110418f502e35c261f3fce3caa0f7.png";